module.exports = __webpack_public_path__ + "img/logo-borme.86fcb575.jpg";